<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
        <TitleTextContent
          :titleText="currentEventPageTitle"
        />
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->

    <div class="events-container container p-0">
      <!-- The Event Search --> 
      <SearchControlWidget
        :inputTextPlaceholder="'Enter event name here'"
        :searchControlHeight="'100px'"
        :searchQueryInputHandler="receiveSearchQuery"
        :searchControlMarginTop="'mt-5'"
      />

      <!-- The Event Toggling Tabs -->
      <section id="toggling-tabs" class="section p-0 mt-3">
        <div class="container-fluid p-0">
          <div class="row toggle-tab">
            <div class="col-4 px-0 d-flex flex-row align-items-center justify-content-end">
              <div class="toggle-tab-item" :class="upcompingEventsTabClass" @click="toggleUpcomingEvents">Upcoming Events</div>
            </div>
            <div class="col-4 px-0 d-flex flex-row align-items-center justify-content-center">
              <div class="toggle-tab-item" :class="pastEventsTabClass" @click="togglePastEvents">Past Events</div>
            </div>
            <div class="col-4 px-0 d-flex flex-row align-items-center justify-content-start">
              <div class="toggle-tab-item" :class="pastEventsVideosTabClass" @click="togglePastEventVideos">Event Videos</div>
            </div>
          </div>
        </div>
      </section>

      <!-- The list of paginated events sorted by date -->
      <section class="section p-0 mt-2">
        <div v-if="currentPageEventItems.length > 0" class="container-fluid p-0 d-flex flex-column align-items-center pt-3 mb-4 px-1 px-md-0 px-lg-0 px-xl-0">
          <div v-if="currentSelection === 'all' || currentSelection === 'upcoming' || currentSelection === 'past'" class="w-100 h-auto">
            <div :id="nextEvent?.id === eventItem.id ? nextEvent.id : eventItem.id" class="row m-0 event-row-item2" v-for="eventItem in currentPageEventItems" :key="eventItem.id">
              <div class="col-12 p-0">
                <div class="row m-0 h-100">
                  <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 p-0">
                    <div class="d-flex flex-row justify-content-center align-items-center event-item-size">
                      <div class="event-image-container2 d-flex flex-column justify-content-center">
                        <img 
                          :src="(eventItem.cyberBannerLink ?? eventItem.imageURL) || require('@assetsImages/services/webinar.jpeg')"
                          alt=""
                          class="event-image-info"
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 p-0 pb-md-0 pb-lg-0 pb-xl-0" :class="(eventItem?.status?.length > 0) && 'pb-3'">
                    <div class="w-100 h-100">
                      <div class="h-100 event-info-container2 px-3 py-3 px-md-2 px-lg-2 px-xl-2 py-md-4 py-lg-4 py-xl-4 d-flex flex-column">
                        <div style="width: 100%; min-height: 10%;" class="row m-0 pb-1">
                          <div class="col-12 p-0 text-left d-flex align-items-end event-info event-info-header">
                            {{ eventItem.title ?? eventItem.eventTitle }}
                          </div>
                        </div>
                        <div style="width: 100%; height: 20%;" class="row m-0">
                          <div class="col-12 p-0 text-left pt-1 event-info event-info-header">
                            {{ formatEventDate(eventItem.startAt ?? eventItem.date)  }}
                          </div>
                        </div>
                        <div style="width: 100%; height: 40%;" class="row m-0 d-flex flex-column justify-content-center">
                          <div class="h-100 col-12 p-0 d-flex flex-column justify-content-start">
                            <div class="event-info event-info-description text-left" v-html="eventItem.headLine ?? eventItem.description">
                            </div>
                          </div>
                        </div>
                        <div style="width: 100%; height: 30%;" class="row m-0">
                          <div v-if="isUpcomingEventsSelected" class="col-12 p-0 d-flex flex-row justify-content-start align-items-end">
                            <router-link
                              :to="{
                                name: eventItem.title ? 'cyber-circuits-detail' : 'event-detail',
                                query: { 
                                  id: eventItem.id, 
                                  eventPage: String(currentEventPage), 
                                  query: eventSearchQuery,
                                  eventType: currentSelection,
                                  isEventArchived: isPastEventsArchived,
                                },
                              }"
                            >
                              <v-btn
                                rounded
                                large
                                dark
                                :color="primaryButtonColor"
                                width="180"
                              >
                                Learn More 
                              </v-btn>
                            </router-link>
                          </div>

                          <div v-else class="col-12 p-0 d-flex align-items-end justify-content-start justify-content-md-end justify-content-lg-end justify-content-xl-end">
                            <div style="position: relative;" class="w-auto h-auto">
                              <img
                                :src="require('@assetsImages/Share-08.svg')"
                                width="20px"
                                height="20px"
                                @click="() => toggleEventCopyUrl(eventItem.id)"
                              />
                              <!-- COPY PAST EVENT URL TO CLIPBOARD -->
                              <CopyUrlClipboard
                                v-if="globalEventItemId === eventItem.id"
                                :class="copyUrlClass"
                                :copyHandlerComplete="() => toggleEventCopyUrl(eventItem.id)"
                                :urlSource="`${urlRootPath}/#/event-detail?id=${globalEventItemId}&eventType=${currentSelection}&eventPage=${currentEventPage}&query=${eventSearchQuery}&isEventArchived=${isPastEventsArchived}`"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- SECTION FOR EVENT VIDEOS TAB CONTENT -->
          <div v-else-if="currentSelection === 'pastEventsWithVideos'" class="w-100 h-auto">
            <div class="row m-0 my-2 event-video-row" v-for="eventItem in currentPageEventItems" :key="eventItem.id">
              <div class="col-12 p-0 p-2 d-flex justify-content-center">
                <div class="h-100 d-flex flex-column justify-content-start" :class="videoContainer">
                  <!-- CONTAINER FOR YOUTUBE EVENT VIDEO DISPLAY -->
                  <div style="height: 60%;" class="w-100 mb-2">
                    <YoutubeVideoWidget
                      :ref="eventItem?.youtubeID"
                      :youtubeID="eventItem?.youtubeID"
                      :options="eventItem?.videoOptions"
                      :status="eventItem?.status"
                      :activeYoutubeID="activeYoutubeID"
                      :updaterHandler="youtubeUpdateOptionsHandler"
                      :pauseYoutubeIDVideo="pauseVideoHandler"
                      @changeYoutubeVideoPlay="changeYoutubeVideoPlayingHandler"
                    />
                  </div>

                  <!-- CONTAINER FOR YOUTUBE EVENT VIDEO TITLE AND DATE -->
                  <div style="height: 10%;" class="w-100 d-flex flex-column mb-2">
                    <div class="w-100 text-left event-info event-info-header d-flex align-items-end flex-grow-1">
                      {{ eventItem.title ?? eventItem.eventTitle }}
                    </div>
                    <div class="w-100 text-left event-info event-info-header d-flex align-items-center flex-grow-1">
                      {{ formatEventDate(eventItem.startAt ?? eventItem.date)  }}
                    </div>
                  </div>

                  <!-- CONTAINER FOR YOUTUBE EVENT VIDEO DESCRIPTION -->
                  <div style="height: 17%;" class="w-100">
                    <div class="h-100 col-12 p-0 d-flex flex-column justify-content-start">
                      <div class="event-info event-info-description text-left" v-html="eventItem.headLine ?? eventItem.description">
                      </div>
                    </div>
                  </div>

                  <!-- CONTAINER FOR YOUTUBE EVENT CONTROLS -->
                  <div style="height: 13%;" class="w-100 d-flex flex-column mb-3">
                    <div class="w-100 flex-grow-1 d-flex justify-content-start align-items-center event-video-status">
                      {{ eventItem.status }}
                    </div>
                    <div class="w-100 d-flex justify-content-start align-items-end">
                      <div class="w-auto d-flex justify-content-center event-videos-ctrl-row">
                        <img
                          style="position: relative; bottom: 0;"
                          :src="require('@assetsImages/youtube-brands-1.svg')"
                          width="30px"
                          height="30px"
                          @click="() => openYoutubeVideo(eventItem?.youtubeID)"
                        />
                        <div style="position: relative;" class="w-auto h-auto d-flex align-items-center">
                          <img
                            :src="require('@assetsImages/Share-08.svg')"
                            width="20px"
                            height="20px"
                            @click="() => toggleEventCopyUrl(eventItem.id)"
                          />
                          <!-- COPY PAST EVENT URL TO CLIPBOARD -->
                          <CopyUrlClipboard
                            v-if="globalEventItemId === eventItem.id"
                            class="share-button-position"
                            :copyHandlerComplete="() => toggleEventCopyUrl(eventItem.id)"
                            :urlSource="`${urlRootPath}/#/event-detail?id=${globalEventItemId}&eventType=${currentSelection}&eventPage=${currentEventPage}&query=${eventSearchQuery}&isEventArchived=${isPastEventsArchived}`"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w-100 row m-0 my-4 d-flex flex-column event-last-row">
            <div v-if="totalEvents > eventsPerPage" class="col-12 p-0">
              <b-pagination
                class="ml-0"
                id="event-list-items"
                v-model="currentEventPage"
                :total-rows="totalEvents"
                :per-page="eventsPerPage"
                align="center"
                @page-click="pageClicked"
              />
            </div>
            <div v-if="isPastEventsSelected" class="col-12 p-0 d-flex justify-content-center">
              <v-btn
                rounded
                large
                dark
                :color="primaryButtonColor"
                width="240"
                @click="isPastEventsArchived = !isPastEventsArchived"
              >
                {{ isPastEventsArchived ? 'Back to Recent Events' : 'View Archives' }}
              </v-btn>
            </div>
          </div>
        </div>
        <div v-else class="container d-flex justify-content-center align-items-center empty-event-message text-center">
          <span>{{ emptyEventsMessage }}</span>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import debounce from "debounce";
import { BPagination, BFormInput } from "bootstrap-vue"
import PageHeader from "../library/widgets/page-header.vue";
import PageHeaderTitleContent from "../library/widgets/page-header-title-content.vue";
import SearchControlWidget from "../library/widgets/search-control-widget.vue";
import TitleTextContent from "../library/widgets/title-text-content.vue";
import CopyUrlClipboard from "../library/widgets/copy-url-clipboard.vue";
import YoutubeVideoWidget from "../library/widgets/youtube-video-widget.vue";
import { EventBus } from "../../utils/eventBus";
import { YOUTUBE_VIDEO_STATUSES } from "../../utils/youtube-statuses";

export default {
  name: "cyber-circuits",
  components: {
    BPagination,
    BFormInput,
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
    SearchControlWidget,
    CopyUrlClipboard,
    YoutubeVideoWidget,
  },
  props: {
    query: String,
    eventPage: String,
    eventType: String,
    eventsArchived: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nextEvent: null,
      // eventsPageTitle: null,
      // eventPageArchiveTitle: null,
      globalEventItemId: null,
      urlRootPath: window.location.origin,

      isUpcomingEventsSelected: false,
      isPastEventsSelected: false,
      isEventsVideosSelected: false,

      eventSearchQuery: "",
      currentEventPage: 1,
      currentSelection: 'all',
      activeYoutubeID: null,

      combined: {
        all: {
          items: [],
          itemCount: 0,
          perPage: 4,
        },
        upcoming: {
          items: [],
          itemCount: 0,
          perPage: 4,
        },
        past: {
          items: [],
          recentItems: [],
          archiveItems: [],
          itemCount: 0,
          perPage: 4,
        },
      },
      eventsVideos: [],
      eventsVideosPerPage: 5,

      emptyEventsMessage: "",
      isQueryValueFromProp: false,
      isEventTypeValueFromProp: false,
      isNextEventWithinDOM: false,
      isPastEventsArchived: false,
      isFromEventsArchievedPage: false,

      events: {
        upcoming: {
          items: [],
          itemCount: 0,
        },
        past: {
          items: [],
          itemCount: 0,
        },
      },
      cyberCircuits: {
        upcoming: {
          items: [],
          itemCount: 0,
        },
        past: {
          items: [],
          itemCount: 0,
        },
      },
    }
  },
  computed: {
    upcompingEventsTabClass() {
      return this.isUpcomingEventsSelected ? 'toggle-tab-active' : 'toggle-tab-inactive';
    },
    pastEventsTabClass() {
      return this.isPastEventsSelected ? 'toggle-tab-active' : 'toggle-tab-inactive';
    },
    pastEventsVideosTabClass() {
      return this.isEventsVideosSelected ? 'toggle-tab-active' : 'toggle-tab-inactive';
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    copyUrlClass() {
      return this.isMobile ? 'share-button-from-left' : 'share-button-from-right';
    },
    buttonsDisplayClass() {
      return this.isLoggedIn || !this.isNextEventWithinDOM ? 'justify-content-center' : 'justify-content-center justify-content-sm-between justify-content-md-between justify-content-lg-between justify-content-xl-between';
    },
    eventsPerPage() {
      if(this.isUpcomingEventsSelected || this.isEventsVideosSelected) {
        if(this.isPastEventsArchived) {
          this.isPastEventsArchived = false;
        }
        if(this.isUpcomingEventsSelected) {
          return this.combined.upcoming.perPage;
        }
        else if(this.isEventsVideosSelected) {
          return this.eventsVideosPerPage;
        }
      }
      else if(this.isPastEventsSelected) {
        return this.combined.past.perPage;
      }
      else {
        return this.combined.all.perPage;
      }
    },
    currentEventPageTitle() {
      return this.isPastEventsArchived ? "Project Spectrum Events Archives" : "Project Spectrum Events";
    },
    currentPageEventItems() {
      let eventPageItems;

      if(this.isUpcomingEventsSelected) {
        this.emptyEventsMessage = "There are no Upcoming Events scheduled."
        eventPageItems = this.combined.upcoming.items;
      }
      else if(this.isPastEventsSelected) {
        this.emptyEventsMessage = "There are no Past Events available."
        eventPageItems = this.isPastEventsArchived ? this.combined.past.archiveItems : this.combined.past.recentItems;
      }
      else if(this.isEventsVideosSelected) {
        this.emptyEventsMessage = "There are no Event Videos available";
        eventPageItems = this.eventsVideos;
      }
      else {
        this.emptyEventsMessage = "There are no Events available."
        eventPageItems = this.combined.all.items;
      }

      if(this.eventSearchQuery !== null && this.eventSearchQuery.trim().length > 0) {
        eventPageItems = eventPageItems.filter(({ title, eventTitle }) => 
          (title?.trim().toLowerCase().includes(this.eventSearchQuery.trim().toLowerCase())) || 
          (eventTitle?.trim().toLowerCase().includes(this.eventSearchQuery.trim().toLowerCase())
        ));
      }

      eventPageItems = eventPageItems.slice(
          (this.currentEventPage - 1) * this.eventsPerPage,
          this.currentEventPage * this.eventsPerPage
      );
      const eventIds = eventPageItems.map(({ id }) => id);
      this.isNextEventWithinDOM = eventIds.includes( this.nextEvent?.id );

      return eventPageItems;
    },
    totalEvents() {
      let totalEventsCount;
      const pastEventItems = this.isPastEventsArchived ? this.combined.past.archiveItems : this.combined.past.recentItems;

      if(this.isUpcomingEventsSelected) {
        totalEventsCount = this.combined.upcoming.itemCount;
      }
      else if(this.isPastEventsSelected) {
        totalEventsCount = pastEventItems.length;
      }
      else if(this.isEventsVideosSelected) {
        totalEventsCount = this.eventsVideos.length;
      }
      else {
        totalEventsCount = this.combined.all.itemCount;
      }

      if(this.eventSearchQuery !== null && this.eventSearchQuery.trim().length > 0) {
        let eventPageItems;

        if(this.isUpcomingEventsSelected) {
          eventPageItems = this.combined.upcoming.items;
        }
        else if(this.isPastEventsSelected) {
          eventPageItems = pastEventItems;
        }
        else if(this.isEventsVideosSelected) {
          eventPageItems = this.eventsVideos;
        }
        else {
          eventPageItems = this.combined.all.items;
        }

        totalEventsCount = eventPageItems.filter(({ title, eventTitle }) => 
          (title?.trim().toLowerCase().includes(this.eventSearchQuery.trim().toLowerCase())) || 
          (eventTitle?.trim().toLowerCase().includes(this.eventSearchQuery.trim().toLowerCase())
        )).length;
      }

      return totalEventsCount;
    },
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    isMobile() {
      return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
    },
    videoContainer() {
      return this.isMobile ? 'event-video-mobile' : 'event-video-desktop';
    }
  },
  mounted: async function () {
    this.currentEventPage = this.eventPage ? parseInt(this.eventPage) : 1;
    this.isQueryValueFromProp = this.query?.length > 0;
    this.isEventTypeValueFromProp = this.eventType === 'upcoming' || this.eventType === 'past' || this.eventType === 'pastEventsWithVideos';
    this.isFromEventsArchievedPage = this.eventsArchived === 'true';
    this.isPastEventsArchived = this.isFromEventsArchievedPage;

    this.dispatchEvent("activate-indicated-menu-item", "Events");
    this.dispatchEvent("update-search-query", this.query);

    await this.getCyberCircuits() // async
    await this.getEvents() // async

    this.getCombinedUpcomingEvents()

    switch(this.eventType) {
      case 'upcoming':
        this.toggleUpcomingEvents();
        break;
      case 'past':
        this.togglePastEvents();
        break;
      case 'pastEventsWithVideos':
        this.togglePastEventVideos();
        break;
      default:
        if(this.currentSelection === "all" && this.combined.upcoming.itemCount > 0) {
          this.toggleUpcomingEvents();
        }
        else {
          this.togglePastEvents();
        }
        console.log('All the events are provided...');
    };

    setInterval(async () => {
      await this.getCyberCircuits();
      await this.getEvents();
      this.getCombinedUpcomingEvents();
    }, 5 * 60 * 1000);
  },
  methods: {
    toggleUpcomingEvents() {
      this.isUpcomingEventsSelected = !this.isUpcomingEventsSelected;
      this.isPastEventsSelected = false;
      this.isEventsVideosSelected = false;
      this.activeYoutubeID = null;
      this.globalEventItemId = null;
      this.resetAllEventYoutubeVideosStatuses();
      if(this.isUpcomingEventsSelected) {
        this.currentSelection = "upcoming"
      }
      else {
        this.currentSelection = "all";
      }
    },
    togglePastEvents() {
      this.isPastEventsSelected = !this.isPastEventsSelected;
      this.isUpcomingEventsSelected = false;
      this.isEventsVideosSelected = false;
      this.activeYoutubeID = null;
      this.globalEventItemId = null;
      this.resetAllEventYoutubeVideosStatuses();
      if(this.isPastEventsSelected) {
        this.currentSelection = "past"
      }
      else {
        this.currentSelection = "all";
      }
    },
    togglePastEventVideos() {
      this.isEventsVideosSelected = !this.isEventsVideosSelected;
      this.isUpcomingEventsSelected = false;
      this.isPastEventsSelected = false;
      this.globalEventItemId = null;
      if(this.isEventsVideosSelected) {
        this.currentSelection = "pastEventsWithVideos";
      }
      else {
        this.currentSelection = "all";
      }
    },
    toggleEventCopyUrl(eventItemId) {
      this.globalEventItemId = (this.globalEventItemId !== eventItemId) ? eventItemId : null;
    },
    getCombinedUpcomingEvents() {
      /* Add locale date string to past CC items and sortable date field to both */
      this.events.past.items.forEach(function (element) {
        element.date = new Date(element.date).toLocaleDateString("en-US", {
          timeZone: "UTC",
        })
        element.sortBy = new Date(element.startAt)
      })
      this.cyberCircuits.past.items.forEach(function (element) {
        element.date = new Date(element.date).toLocaleDateString("en-US", {
          timeZone: "UTC",
        })
        element.sortBy = new Date(element.date)
      })
      /* Concatenate past CC and Event items into one list */
      this.combined.past.items = this.cyberCircuits.past.items.concat(
        this.events.past.items
      );

      this.combined.past.itemCount = this.combined.past.items.length;

      /* Label upcoming CC items and maye date a JS date */
      this.cyberCircuits.upcoming.items.forEach(function (element) {
        element.type = "circuits"
        element.date = new Date(element.date)
        element.sortBy = new Date(element.date)
      })
      /* Label upcoming Event items */
      this.events.upcoming.items.forEach(function (element) {
        element.type = "events"
        element.sortBy = new Date(element.startAt)
      })
      /* Concatenate upcoming CC and Event items into one list */
      this.combined.upcoming.items = this.cyberCircuits.upcoming.items.concat(
        this.events.upcoming.items
      )
      this.combined.upcoming.itemCount = this.combined.upcoming.items.length;

      /* Sort all upcoming CC and Event items */
      this.combined.upcoming.items = this.combined.upcoming.items.sort((a, b) =>
        a.sortBy > b.sortBy ? 1 : -1
      )
      /* Sort all past CC and Event items */
      this.combined.past.items = this.combined.past.items.sort((a, b) =>
        a.sortBy < b.sortBy ? 1 : -1
      )

      /* Separate the past events into pastEventWithinLastSixMonths and pastEventsOlderThanLastSixMonths */
      const today = moment().valueOf();
      const fromTheLastSixMonths = moment().subtract(6, 'months').valueOf();
      this.combined.past.recentItems = this.combined.past.items.filter(({ startAt }) => (moment(startAt).valueOf() > fromTheLastSixMonths) && (moment(startAt).valueOf() < today));
      this.combined.past.archiveItems = this.combined.past.items.filter(({ startAt }) => moment(startAt).valueOf() < fromTheLastSixMonths);

      /* Concatenate all CC and Event items and sort into one list */
      this.combined.all.items = [ ...this.combined.upcoming.items, ...this.combined.past.items, ];
      this.combined.all.itemCount = this.combined.all.items.length;

      /* Set the event title for the event archive pages */
      // this.eventPageArchiveTitle = "Project Spectrum Events Archives";

      /* The past events with youtube video ids */
      if(this.eventsVideos.length === 0) {
        const eventsVideos = this.combined.past.items
                                .filter(({ youtubeID }) => youtubeID)
                                .map(eventItem => {
                                    eventItem.status = "";
                                    eventItem.videoOptions = { start: 0 };
                                    return eventItem;
                                });

        // THIS IMPLEMENTATION IS NEEDED TO PREVENT THE POSSIBLE MISTAKE OF A USER OR CA FROM ADDING MULTIPLE EVENTS WITH SIMILAR YOUTUBE IDS
        const youtubeIDs = Array.from(new Set(eventsVideos.map(({ youtubeID }) => youtubeID)));
        this.eventsVideos = youtubeIDs.map((__youtubeID) => eventsVideos.find(({ youtubeID }) => youtubeID === __youtubeID));
       }
    },
    pageClicked(bvEvent, page) {
      if(this.isEventsVideosSelected && this.activeYoutubeID) {
        const videoPlayer = this.$refs[this.activeYoutubeID][0].$children[0].player;
        videoPlayer
          .pauseVideo()
          .then((response) => {
            const currentTime = response.getCurrentTime();
            this.youtubeUpdateOptionsHandler(this.activeYoutubeID, YOUTUBE_VIDEO_STATUSES.PAUSED, currentTime);
            this.activeYoutubeID = null;
          });
      }

      this.updateUrlQueryParam(
        '#/events', 
        [
          { param: 'eventPage', value: page }
        ]
      );

      setTimeout(() => {
        document
          .getElementById("search-query-control")
          .scrollIntoView({ behavior: "smooth", block: "start" });
      }, 500);
    },
    dispatchEvent(eventName, eventValue){
      EventBus.$emit(eventName, eventValue);      
    },
    formatEventDate(eventDate) {
      return moment(eventDate).format('MM/DD/YYYY');
    },
    receiveSearchQuery(searchQuery){
      this.eventSearchQuery = searchQuery;
    },
    resetAllEventYoutubeVideosStatuses() {
      this.eventsVideos.forEach((eventItem) => {
        eventItem.status = "";
        eventItem.videoOptions = { start: 0 };
      });
    },
    youtubeUpdateOptionsHandler(currentYoutubeID, currentVideoStatus = "", currentVideoTime = 0) {
      const currentEvent = this.eventsVideos.find(({ youtubeID }) => youtubeID === currentYoutubeID);
      currentEvent.videoOptions.start = Math.round(currentVideoTime);
      currentEvent.status = currentVideoStatus;
      this.eventsVideos = [ ...this.eventsVideos ];
    },
    pauseVideoHandler(currentYoutubeID) {
      const videoReference = this.$refs[currentYoutubeID][0];
      videoReference.pauseYoutubeVideo();
    },
    changeYoutubeVideoPlayingHandler(youtubeID) {
      this.activeYoutubeID = youtubeID;
    },
    openYoutubeVideo(youtubeID) {
      window.open(`https://www.youtube.com/watch?v=${youtubeID}`, '_blank');
    }
  },
  watch: {
    isPastEventsArchived(newValue) {
      this.currentEventPage = (newValue && this.isFromEventsArchievedPage) ? this.currentEventPage : 1;
      this.isFromEventsArchievedPage = false;

      this.updateUrlQueryParam(
        '#/events', 
        [
          { param: 'eventPage', value: this.currentEventPage }, 
          { param: 'eventsArchived', value: false }
        ]
      );
    },
    currentSelection(newValue){
      if(!this.isEventTypeValueFromProp) {
        this.currentEventPage = 1;

        this.updateUrlQueryParam(
          '#/events', 
          [
            { param: 'eventPage', value: this.currentEventPage }, 
            { param: 'eventType', value: newValue }
          ]
        );
      }
      else {
        this.isEventTypeValueFromProp = false;
      }
    },
    eventSearchQuery(newValue) {
      if(!this.isQueryValueFromProp) {
        this.currentEventPage = 1;

        debounce(
          () => {
            this.updateUrlQueryParam(
              '#/events', 
              [
                { param: 'eventPage', value: this.currentEventPage }, 
                { param: 'query', value: newValue }
              ]
            );
          }, 
          1000, 
          { immediate: false }
        ).call(this);
      }
      else {
        this.isQueryValueFromProp = false;
      }
    }
  },
}
</script>
<style scoped>
.inner-header-bg {
  background-image: url("~@/assets/images/headers/events.png");
  background-position: center center;
}
#blog-pagination li {
  margin: 0px;
}

.events-container {
  min-width: 370px;
}

.cover {
  object-fit: cover;
  height: 225px;
  width: 100%;
}

.tool-icon {
  object-fit: cover;
  height: 50px;
  width: 80px;
  margin-right: 10px;
}

.image-and-tool {
  max-width: 325px;
  align-items: center;
}

.btn-more {
  width: 100px;
  height: auto;
  padding: 0.25rem 0.5rem;
}

.toggle-tab {
  height: 80px;
}
.toggle-tab-item {
  width: auto;
  height: 100%;
  text-align: center;
  font-family: Rajdhani;
  font-size: clamp(14px, 2vw, 18px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.toggle-tab-active {
  color: #424EC4;
}
.toggle-tab-inactive {
  color: #000000;
}

.empty-event-message {
  height: 300px;
  font-weight: 700;
  font-size: 28px;
  font-family: Rajdhani;
}
.event-row-item2 {
  border-radius: 10px;
  background-color: #F7F7F7;
  margin-bottom: 10px !important;
  width: 100%;
  min-height: 250px;
}
.event-item-size {
  width: 100%;
  height: 100%;  
}
.event-image-container2 {
  width: auto;
  aspect-ratio: 16 / 9;
  padding: 2px;
  margin: 5px 8px;
  border-radius: 5px;
  overflow: hidden;
}
.event-image-info {
  width: auto;
  height: auto;
  aspect-ratio: 16 / 9;
  border-radius: 5px;
}
.share-button-from-right {
  bottom: -44px;
  right: 0;
}
.share-button-from-left {
  bottom: -44px;
  left: 0;
}
.share-button-position {
  bottom: -5px;
  right: -125px;
}
.event-info-container2 {
  min-height: 300px;
}
.event-info {
  color: #000;
  font-family: Rajdhani;
  font-size: clamp(15px, 2vw, 18px);
  font-style: normal;
  line-height: 20px;
}
.event-info-header {
  font-weight: 700;
  word-break: normal;
  text-overflow: ellipsis;
}
.event-info-description {
  font-weight: 400;
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 4;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
.event-info-description :deep p {
  margin-bottom: 0 !important;
}

.event-video-status {
  font-size: clamp(14px, 2vw, 16px);
  font-weight: bold;
  font-family: Rajdhani;
  color: #272727;
}
.event-videos-ctrl-row {
  gap: 15px;
}
.event-last-row {
  gap: 30px;
}
.event-last-row ul {
  margin: 0;
}

.event-video-row {
  min-height: 600px;
}
.event-video-desktop {
  width: 55%;
  border-bottom: 2px solid #000000;
}
.event-video-mobile {
  width: 100%;
  border-bottom: 2px solid #000000;
}
</style>
